import { useTheme } from 'next-themes';
import { type ReactNode } from 'react';

import dotBgDark from './assets/dot-bg.dark.png';
import dotBgLight from './assets/dot-bg.light.png';
import * as styles from './index.css';

export const AffineOtherPageLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { resolvedTheme } = useTheme();
  const backgroundImage =
    resolvedTheme === 'dark' && dotBgDark ? dotBgDark : dotBgLight;

  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Card 1854540586736944835 — a barra de MARKETING do upstream sai desta instalação.

          Ela desenhava, na tela de login (a página mais vista do ambiente): o logotipo do
          AFFiNE, "Official website" → affine.pro, "Blog" → affine.pro/blog, "Contact us" →
          affine.pro/about-us, e um botão "Download app" apontando para o aplicativo de
          desktop deles.

          ⚠️ **Não é só marca — é link errado.** Numa instalação privada, "Baixar aplicativo"
          leva a um programa que não fala com este servidor, e "Site oficial" leva ao produto
          de outra empresa. Quem clicasse sairia do ambiente sem entender por quê.

          Foi achado no PRINT e não no dado (Regra 8.51): `serverConfig.name`, o `<title>` e o
          manifest já diziam "Mirezi", e a tela continuava com a marca em cinco lugares.

          A navegação NÃO se perde: a barra da plataforma (`<tuninho-barra>`, patch 0010) fica
          acima desta área e lista as ferramentas do ambiente. O que sai é a barra que aponta
          para fora dele.

          Fica o `draggableHeader` do Electron — não construímos desktop, e removê-lo mexeria
          num caminho que este ambiente não exercita. */}
      <div className={styles.draggableHeader} />

      {children}
    </div>
  );
};
